import { forwardRef } from 'react';

import { SwitchProps, Switch as MantineSwitch } from '@mantine/core';

const Switch = forwardRef<HTMLInputElement, SwitchProps>((props, ref) => {
  return <MantineSwitch {...props} ref={ref} />;
});

export { Switch };
export type { SwitchProps };
